export enum LassoConfiguration {
  LassoTool = 'LassoTool',
  RoutingSelection = 'RoutingSelection'
}

export type LassoState = Readonly<{
  isActive: false;
  isDrawing: false;
} | {
  isActive: true;
  isDrawing: boolean;
  configuration: LassoConfiguration;
}>;
